import { from } from 'rxjs';

import {
  ships,
  voyagesEntries,
  voyagesPositions
} from './data';
import { User } from './types';
import { ServerError } from './errors';


const BASE_PATH = 'https://' + process.env.REACT_APP_CMS_DOMAIN;
const BASE_ANCHOR_PATH = BASE_PATH + '/anchor/api/';

async function getData (endpoint: string, id?: string, dataType?: string, fallbackValue?: any ){
  // let localStorageKey =id+dataType; 
  try {
    const response = await fetch(endpoint, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'Client-Id': 'mobile',
        'x-mobile-app': 'ship',
      },
    });
    if (!response.ok) {
      const text = await response.text();
      throw new ServerError(response.status, undefined, JSON.parse(text));
    }
    const data = (await response.json());
    // localStorage.setItem(localStorageKey, JSON.stringify(data));
    return data?.results ?? data; // results is only defined for anchor requests

  } catch (error) {
    // let data = localStorage.getItem(localStorageKey);
    // if(data){
    //   return JSON.parse(data);
    // }else{

    // UNCOMMENT TO ENABLE FALLBACK VALUES
    // if(fallbackValue && false){
    //   console.log('returning fallback value', fallbackValue);
    //   return fallbackValue.results;
    // }

    if (error instanceof ServerError) {
      throw error;
    } else if (error instanceof Error) {
      throw new ServerError(0, error);
    }
    throw error;
  }
}

function getPorts (region: string) { 
  const JPM = BASE_ANCHOR_PATH + 'search?r=jpm&t=entries&q=data.region:' + region + '&hydrate=true';

  return getData(JPM, undefined, undefined, voyagesPositions["test"]);
}



//Each of the async functions will attempt to use the REACT_APP_CMS_DOMAIN for data
//If the call fails the function will use the fallback data
function getVoyagePositions (id: string, shipCode?: string, startDate?: string, endDate?: string) {
  const anchorEndpoint = BASE_ANCHOR_PATH +
  `search?r=ventures&t=voyage-positions&q=references(content/ventures/voyages/${id})&hydrate=true`;
  const shipLocationEndpoint = BASE_PATH +
  `/shipLocation/v1.0.0/shipCode/${shipCode}/start/${startDate}/end/${endDate}`;
  const getAnchorData = getData(anchorEndpoint, id, "Position", voyagesPositions[id]);
  const getLocationData = getData(shipLocationEndpoint, id, "Position", voyagesPositions[id]);
  return Promise.all([getAnchorData, getLocationData]);
}

function getVoyageEntries (id: string) {

  const endpoint = BASE_ANCHOR_PATH + 'search?r=ventures&t=entries&q=references(content/ventures/voyages/' + id + ')&orderby=data.date&hydrate=true';
  return getData(endpoint, id, "Entries", voyagesEntries[id]);

}

function getVoyageBulletin (id: string) {

  const endpoint = BASE_ANCHOR_PATH + 'search?r=ventures&t=bulletin&q=references(content/ventures/voyages/' + id + ')&hydrate=true';
  return getData(endpoint);

}

function getVoyageWeblinks (id: string) {

  const endpoint = BASE_ANCHOR_PATH + 'search?r=ventures&t=links&q=references(content/ventures/voyages/' + id + ')&hydrate=true';
  return getData(endpoint);

}

function getShipVoyages (id: string) {

  const endpoint = BASE_ANCHOR_PATH + 'search?r=ventures&t=voyages&q=data.ship:=' + id + '&orderby=data.dateStart+DESC&hydrate=true';

  return getData(endpoint, id, "Voyages", ships[id]);
}

function getSpecies () {

  const endpoint = BASE_ANCHOR_PATH + '/search?r=ventures&t=species&hydrate=true';

  return getData(endpoint);
}

async function getItinerary (dateFrom: string, dateTo: string, ship: string){
  try {
    const endpoint = await fetch(
      BASE_PATH + '/shipinfo/v1.0.0/shipItinerary?from=' + dateFrom
        + '&to=' + dateTo
        + '&shipCode=' + ship, {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          'Client-Id': 'mobile',
          'x-mobile-app': 'ship',
        },
      });

    const response = (await endpoint.json());
    return response;
    
  } catch (error) {
    return error;
  }
}

async function login (user: User){
  const formData = new URLSearchParams();

  formData.append('key', user.username);
  formData.append('secret', user.secret);
  try {

    const endpoint = await fetch(BASE_PATH + '/authentication/v2.0.0/companyCode/SBN', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        'Client-Id': 'mobile',
        'x-mobile-app': 'ship',
      },
      body: formData.toString(),
    });

    const response = (await endpoint.json());
    localStorage.setItem('user', JSON.stringify(response));

    return response;

    
  } catch (error) {
    return error;
  }
}

async function verifyToken (token: string){

  try {
    const url = `${BASE_PATH}/authentication/v2.0.0/companyCode/SBN/${token}`;
    const endpoint = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'Client-Id': 'mobile',
        'x-mobile-app': 'ship',
      },
    });

    const response = (await endpoint.json());
    return response;

    
  } catch (error) {
    return error;
  }
}

async function getShipLocationData (){
  const endpoint = 'https://moapp-source.seabourn.com/ds-public/api/weather/v1.0.0/fleetStatus';
  try {
    const response = await fetch(endpoint, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'Client-Id': 'mobile',
        'x-mobile-app': 'ship',
      },
    });
    const data = (await response.json()).Content;
    return data;

  } catch (error) {
    return [];
  }
  
}

export default {
  fetchVoyagePositions: (id: string, shipCode?: string, startDate?: string, endDate?: string) => from(getVoyagePositions(id, shipCode, startDate, endDate)),
  fetchVoyageEntries: (id: string) => from(getVoyageEntries(id)),
  fetchVoyages: (id: string) => from(getShipVoyages(id)),
  fetchShipLocations: () => from(getShipLocationData()),
  getLoginData: (user: User) => from(login(user)),
  verifyUserToken: (token: string) => from(verifyToken(token)),
  getPorts: (region: string) => from(getPorts(region)),
  getSpecies: () => from (getSpecies()),
  getVoyageBulletin: (id: string) => from(getVoyageBulletin(id)),
  getVoyageWeblinks: (id: string) => from(getVoyageWeblinks(id)),
  fetchShipItinerary: (dateFrom: string, dateTo: string, ship: string) => from(getItinerary(dateFrom, dateTo, ship)),
};